// RecordOrderSearch.js
import React, { useEffect, useState } from "react";
import Select from "react-select";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";

import "../../../css/components/Delivery/Delivery.css";

import { formatTaiwanDate, formatTaiwanDateTime } from "../../../utils";
import { GenericModal, Message } from "../..";
import { useUser } from "../../../hooks/useUser";

import { Calendar } from "../Calendar/Calendar";
import { EditStaffOrderModal } from "../../StaffOrder/EditStaffOrderModal/EditStaffOrderModal";
import { roleConfig } from "../../../constants/roleConfig";

import { getDeliverOrders, getOrders } from "../../../service/api/Order/apiOrder";
import { getDeliver } from "../../../service/api/Deliver/apiDeliver";
import RoleGuard from "../../RoleGuard/RoleGuard";

const RecordOrderSearch = ({ staffO, records, deliver, setDeliver, handleSubmitDeliver, selectedRecord, setSelectedRecord, setOrders, loginCheck }) => {
    const [staffOrder, setStaffOrder] = useState([]);
    const [editData, setEditData] = useState(false);
    const [selectedDeliverOrder, setSelectedDeliverOrder] = useState(null); //選中的派送單
    const { id, role, companyId } = useUser();
    const [deliversData, setDeliversData] = useState([]); // 司機列表

    const navigate = useNavigate();

    useEffect(() => {
        if (staffO) {
            setStaffOrder(staffO);
        }
    }, [staffO]);

    // (2) records 更新後再根據 deliver.setRecord 自動選中紀錄
    useEffect(() => {
        if (records.length > 0 && deliver?.setRecord) {
            const match = records.find(r => String(r.id) === String(deliver.setRecord));
            console.log("自動匹配紀錄:", match);
            console.log("records:", records);
            if (match) {
                setSelectedRecord(match);
            }
        }
    }, [records, deliver]);
    // ---------------

    // 在選中派送單的時候，自動送出api 取得該司機的紀錄的訂單
    useEffect(() => {
        const fetchOrders = async () => {
            console.log(selectedDeliverOrder);
            if (!selectedDeliverOrder) return;

            console.log("選中派送單：", selectedDeliverOrder);

            const response = await getOrders({ deliverOrderId: selectedDeliverOrder.id });

            if (response.status === 200) {
                const resultOrders = response.data.result;
                if (!resultOrders || resultOrders.length === 0) {
                    Message("此紀錄沒有訂單！");
                    setOrders([]);
                    return;
                }
                setOrders(resultOrders);
            } else {
                alert("取得訂單失敗，請稍後再試！");
            }
        };
        fetchOrders();
    }, [selectedDeliverOrder]);

    // 在選中記錄的時候，自動送出api 取得該司機的紀錄的訂單
    useEffect(() => {
        const fetchOrders = async () => {
            console.log(selectedRecord);
            if (!selectedRecord) return;
            if (selectedRecord.orderId.length <= 0) {
                Message('此紀錄沒有訂單！');
                return;
            };

            console.log("選中紀錄：", selectedRecord);

            const response = await getDeliverOrders({ orderId: selectedRecord.orderId });

            if (response.status === 200) {
                const resultOrders = response.data.result;
                if (!resultOrders || resultOrders.length === 0) {
                    Message("此紀錄沒有訂單！");
                    setOrders([]);
                    return;
                }
                setOrders(resultOrders);
            } else {
                alert("取得訂單失敗，請稍後再試！");
            }
        };
        fetchOrders();
    }, [selectedRecord]);

    useEffect(() => {
        const query = {};
        if (!editData) return;
        if (role === roleConfig['管理者'] && companyId) {
            query.companyId = companyId;
        } else if (role < roleConfig['財務'] || role === roleConfig['個人']) {
            query.id = id;
        }
        console.log("Fetch delivers with query:", query);
        getDeliver(query)
            .then(response => {
                if (response?.status === 200) {
                    console.log(response)
                    setDeliversData(response.data.result);
                }
            });
    }, [editData]);

    return (
        <>
            <GenericModal isOpen={editData}>
                <EditStaffOrderModal
                    order={editData}
                    onClose={() => setEditData(false)}
                    mode={'deliver'}
                    deliversData={deliversData}
                />
            </GenericModal>
            <div className="driver-select" style={{ marginBottom: '30px' }}>
                <h3 className="driver-title">操作</h3>
                <button
                    className="driver-btn"
                    type="button"
                    onClick={() => navigate('/SKAManager/DeliverInfo')}

                >
                    司機管理
                </button>
                <button
                    className="driver-btn"
                    type="button"
                    onClick={() => navigate('/SKAManager/VehicleManagement')}
                >
                    車輛管理
                </button>
                <button
                    className="driver-btn"
                    type="button"
                    onClick={() => navigate('/SKAManager/DeliverOrder')}
                >
                    填寫派車單
                </button>
            </div>

            <RoleGuard requiredRole={roleConfig['維護者']}>
                <div className="record-select mb-5 ms-4 me-4">
                    <h3 className="driver-title">你好! {records[0]?.deliverName} 選擇要查看的派送紀錄</h3>
                    <Select
                        classNamePrefix="deliverRecord-select"
                        placeholder="請選擇派送紀錄"
                        isSearchable={false}
                        options={records.map((rec) => ({
                            value: rec.id,
                            label: `${formatTaiwanDate(rec.deliveryDate)} - ${rec.mapUrl ? "有路線" : "無路線"
                                } (訂單數:${rec.orderId.length}) ${rec.status ? "已完成" : "未完成"}`,
                            isDisabled: !rec.orderId || rec.orderId.length <= 0 || rec.status,
                        }))}
                        onChange={(option) => {
                            const record = records.find(r => r.id === option.value);
                            setSelectedRecord(record);
                            Cookies.set("deliver_record", record.id, { expires: 7 });
                        }}
                    />
                </div>
            </RoleGuard>

            <div className="record-select mb-5 ms-4 me-4">
                <h3 className="driver-title">選擇要查看的派送單訂單</h3>
                <Select
                    classNamePrefix="deliverRecord-select"
                    placeholder={`請選擇派送單 (${staffOrder.filter(order => order.employeeId === id && new Date(formatTaiwanDateTime(order.usedAt)) > new Date() && order.status === 0).length})`}
                    isSearchable={false}
                    options={staffOrder.filter(order => order.employeeId === id && new Date(formatTaiwanDateTime(order.usedAt)) > new Date() && order.status === 0).map((order) => ({
                        value: order.id,
                        label: `ID: ${order.id} - ${formatTaiwanDate(order.usedAt)} - 車牌:  ${order.plate} (訂單數:${order.orderCount})`,
                    }))}
                    onChange={(option) => {
                        const order = staffOrder.find(o => o.id === option.value);
                        setSelectedDeliverOrder(order);
                        Cookies.set("deliver_order_id", order.id, { expires: 7 });
                    }}
                />
            </div>

            <div className="DeliveryCalendar">
                <Calendar
                    staffOrder={staffOrder}
                    record={records}
                    setEditData={setEditData}
                    loginCheck={loginCheck}
                />
            </div>
        </>
    );
};

export { RecordOrderSearch };
